import {EntityType} from "../@core/entityType";
import {Operation} from "reactcoregk";

export const entityType = EntityType.CveDefinition;
export const entityOperations = [
  Operation.getAllPageable,
  Operation.update,
];
